import { Link } from 'react-router'
import Logo from '@/components/Logo'
import { useT } from '@/i18n/useT'

export default function Footer() {
  const t = useT()

  const cols = [
    {
      title: t.footer.product,
      items: [
        { label: t.nav.features, to: '/features' },
        { label: t.nav.pricing, to: '/pricing' },
        { label: t.nav.integrations, to: '/integrations' },
        { label: t.nav.tools, to: '/tools' },
      ],
    },
    {
      title: t.footer.resources,
      items: [
        { label: t.footer.demo, to: '/book-a-demo' },
        { label: t.footer.partner, to: '/pro-partners' },
      ],
    },
    {
      title: t.footer.company,
      items: [
        { label: t.footer.privacy, to: '#' },
        { label: t.footer.terms, to: '#' },
      ],
    },
  ]

  return (
    <footer className="bg-ink text-slate-300">
      <div className="mx-auto max-w-7xl px-8 py-16 grid grid-cols-12 gap-10">
        <div className="col-span-5">
          <div className="flex items-center mb-5">
            <Logo tone="grey" className="h-7 w-auto" />
          </div>
          <p className="text-[15px] leading-relaxed text-slate-400 max-w-sm">
            {t.footer.tagline}
          </p>
          <div className="mt-6 text-[15px] space-y-1.5 text-slate-400">
            <p>#229-1550 South Gateway Rd, Mississauga, ON L4W 5G6</p>
            <p>
              <a href="tel:+14163632226" className="hover:text-white">416.363.2226 x1</a>
              {' · '}
              <a href="tel:+18776960336" className="hover:text-white">1.877.696.0336 x1</a>
            </p>
            <p>
              <a href="mailto:info@simplepay.ca" className="hover:text-white">info@simplepay.ca</a>
            </p>
          </div>
        </div>

        {cols.map((c) => (
          <div key={c.title} className="col-span-2">
            <h4 className="text-white text-sm font-semibold uppercase tracking-wider mb-4">
              {c.title}
            </h4>
            <ul className="space-y-2.5">
              {c.items.map((i) => (
                <li key={i.label}>
                  <Link to={i.to} className="text-[15px] text-slate-400 hover:text-white transition-colors">
                    {i.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-8 py-6 flex items-center justify-between text-sm text-slate-500">
          <p>{t.footer.rights}</p>
          <p>{t.footer.mockup}</p>
        </div>
      </div>
    </footer>
  )
}
